import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTheme } from "@/providers/ThemeProvider";

/**
 * Syncs the native app background color with the current theme on every page navigation
 * This ensures the background color is always correct even if something interferes with it
 */
const NativelyBackgroundSync = () => {
  const { pathname } = useLocation();
  const { theme } = useTheme();

  useEffect(() => {
    // Only run in native app environment
    if (typeof window !== 'undefined' && window.natively?.setAppBackgroundColor) {
      const bgColor = theme === 'dark' ? '#09090b' : theme === 'system' ? '#1a1a1a' : '#ffffff';
      window.natively.setAppBackgroundColor(bgColor);
      console.log(`[NativelyBackgroundSync] Set background to ${bgColor} for ${theme} mode on ${pathname}`);
    }
  }, [pathname, theme]);

  return null;
};

export default NativelyBackgroundSync;
